export default {
  Idea: 0, 
  Issue: 1
};
